import axios from "axios";

function saveSettlementPrices(productsList, fx) {
  return axios.post("/api/saveSettlementPrices", { productsList, fx });
}

export { saveSettlementPrices };
